// removed by extract-text-webpack-plugin
module.exports = {"DataTable":"mkVjdyH0zuKYyvWJEcriq","dataItem":"_29YXBAN-kxVJ44m0mff_gI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataTable/DataTable.css
// module id = 303
// module chunks = 8